// Change tab class and display content
document.querySelectorAll('.parent-tab-heading a')?.forEach((tabLink) => {
  tabLink.addEventListener('click', function (event) {
    event.preventDefault();

    // Remove 'tab-active' class from all tabs
    document.querySelectorAll('.parent-tab-heading li').forEach((tab) => {
      tab.classList.remove('tab-active');
    });

    document.querySelectorAll('.child-tab-heading li').forEach((tab) => {
      tab.classList.remove('tab-active');
    });

    // Add 'tab-active' class to the clicked tab
    this.parentNode.classList.add('tab-active');

    // Hide all tab content
    document
      .querySelectorAll('.tabs-stage .parent-tab-contents')
      .forEach((div) => {
        div.classList.add('hidden');
      });

    // Show the selected tab content
    var targetTabContent = document.querySelector(this.getAttribute('href'));
    if (targetTabContent) {
      targetTabContent.classList.remove('hidden');
      targetTabContent
        .querySelector('.child-tab-heading li')
        ?.classList.add('tab-active');
    }
  });
});

document.querySelectorAll('.child-tab-heading a').forEach((tabLink) => {
  tabLink.addEventListener('click', function (event) {
    event.preventDefault();

    // Remove 'tab-active' class from all tabs
    document.querySelectorAll('.child-tab-heading li').forEach((tab) => {
      tab.classList.remove('tab-active');
    });

    // Add 'tab-active' class to the clicked tab
    this.parentNode.classList.add('tab-active');

    document
      .querySelectorAll('.main-child-content .child-tab-contents')
      .forEach((div) => {
        div.classList.add('hidden');
      });

    // Show the selected tab content
    var targetTabContent = document.querySelector(this.getAttribute('href'));
    if (targetTabContent) {
      targetTabContent.classList.remove('hidden');
    }
  });
});

function addSizeChartLogic(mainSizeChart) {
  var sizeChartControlPrev = mainSizeChart.querySelector(
    '.scroll-controls .scroll-previous',
  );
  var sizeChartControlNext = mainSizeChart.querySelector(
    '.scroll-controls .scroll-next',
  );
  var scrollItems = mainSizeChart.querySelectorAll(
    '.scroll-area .scroll-area-item',
  );
  var sizeChartTable = mainSizeChart.querySelector('.product-size-chart-main');
  var totalScrollableWidth =
    sizeChartTable.scrollWidth - sizeChartTable.clientWidth;
  var scrollAmount = totalScrollableWidth;

  function updateScroll(direction) {
    let currentScroll = sizeChartTable.scrollLeft;

    if (direction === 'next') {
      sizeChartTable.scrollBy({left: scrollAmount, behavior: 'smooth'});
      currentScroll += scrollAmount;
    } else if (direction === 'prev') {
      sizeChartTable.scrollBy({left: -scrollAmount, behavior: 'smooth'});
      currentScroll -= scrollAmount;
    }

    setTimeout(() => {
      currentScroll = sizeChartTable.scrollLeft;
      sizeChartControlPrev.disabled = currentScroll <= 0;
      sizeChartControlNext.disabled = currentScroll >= totalScrollableWidth;

      var activeIndex = Array.from(scrollItems).findIndex((item) =>
        item.classList.contains('active'),
      );
      if (direction === 'next' && activeIndex < scrollItems.length - 1) {
        scrollItems[activeIndex].classList.remove('active');
        scrollItems[activeIndex + 1].classList.add('active');
      } else if (direction === 'prev' && activeIndex > 0) {
        scrollItems[activeIndex].classList.remove('active');
        scrollItems[activeIndex - 1].classList.add('active');
      }
    }, 300);
  }

  sizeChartControlPrev.addEventListener('click', () => updateScroll('prev'));
  sizeChartControlNext.addEventListener('click', () => updateScroll('next'));
  sizeChartControlPrev.disabled = sizeChartTable.scrollLeft <= 0;
  sizeChartControlNext.disabled =
    sizeChartTable.scrollLeft >= totalScrollableWidth;

    function hideTableControls() {
      if (sizeChartTable.scrollWidth <= sizeChartTable.clientWidth) {
        mainSizeChart.classList.add('hide-controls');
      } else {
        mainSizeChart.classList.remove('hide-controls');
      }
    }
    hideTableControls();
    window.addEventListener('resize', hideTableControls);
}

var mainSizeCharts = document.querySelectorAll('.main-size-chart');
mainSizeCharts.forEach((mainSizeChart) => {
  addSizeChartLogic(mainSizeChart);
});
var childTabs = document.querySelectorAll(
  '.main-child-content .child-tab-contents',
);
if (childTabs.length > 1)
  childTabs[childTabs.length - 1]?.classList.add('hidden');

var scrollContents = document.querySelectorAll('.product-size-chart-main');
var scrollbarThumbs = document.querySelectorAll('.custom-scrollbar-thumb');
var scrollbars = document.querySelectorAll('.custom-scrollbar');

function updateScrollbar(scrollContent, scrollbarThumb) {
  var contentWidth = scrollContent.scrollWidth;
  var visibleWidth = scrollContent.offsetWidth;
  var scrollPosition = scrollContent.scrollLeft;

  var thumbWidth = (visibleWidth / contentWidth) * 100;
  var thumbPosition = (scrollPosition / contentWidth) * 100;

  scrollbarThumb.style.width = `${thumbWidth}%`;
  scrollbarThumb.style.left = `${thumbPosition}%`;
}

scrollContents.forEach((scrollContent, index) => {
  var scrollbarThumb = scrollbarThumbs[index];
  scrollContent.addEventListener('scroll', () =>
    updateScrollbar(scrollContent, scrollbarThumb),
  );
  updateScrollbar(scrollContent, scrollbarThumb);
});
